/**
 * src/shell/ui/desk-todo.ts — 桌面文件堆待办语义（缺陷 C 修复，2026-08-15 拍板）。
 *
 * 「待办即风景」统一容器：待拍板决策 + 待上架卡带共用一个计数，
 * 驱动文件堆高矮（stackCls）与 badge 文案。纯函数抽出供回归测试。
 */

import { COPY } from '../copy'

export type StackCls = 'stack-empty' | 'stack-low' | 'stack-high'

/** 文件堆高矮：0=空 / 1–2=矮 / >2=高 */
export function deskTodoStackCls(todoCount: number): StackCls {
  return todoCount === 0 ? 'stack-empty' : todoCount <= 2 ? 'stack-low' : 'stack-high'
}

/** badge 三态：只有决策 / 只有待上架 / 两者都有（· 拼接）；空 = emptyPapers */
export function deskTodoBadge(pendingDecisions: number, inReview: number): string {
  const C = COPY.cockpit
  if (pendingDecisions + inReview === 0) return C.emptyPapers
  return [
    pendingDecisions > 0 ? C.pendingDecisions(pendingDecisions) : '',
    inReview > 0 ? C.pendingPublish(inReview) : '',
  ]
    .filter(Boolean)
    .join(' · ')
}
